import { render, staticRenderFns } from "./newsDs.vue?vue&type=template&id=398adb16&"
import script from "./newsDs.vue?vue&type=script&lang=js&"
export * from "./newsDs.vue?vue&type=script&lang=js&"
import style0 from "./newsDs.vue?vue&type=style&index=0&id=398adb16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports